import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Users, Upload, MessageSquare, Menu, ClipboardCheck, Building2, User } from 'lucide-react';
import { haptic } from '../native';

const REP_TABS = [
  { path: '/', icon: LayoutDashboard, label: 'Home' },
  { path: '/clients', icon: Users, label: 'Clients' },
  { path: '/upload', icon: Upload, label: 'Upload' },
  { path: '/messages', icon: MessageSquare, label: 'Messages' },
];

// Clients have no sidebar on phones, so these tabs are their only way between pages.
const CLIENT_TABS = [
  { path: '/upload', icon: Upload, label: 'Upload' },
  { path: '/status', icon: ClipboardCheck, label: 'Status' },
  { path: '/businesses', icon: Building2, label: 'Businesses' },
  { path: '/profile', icon: User, label: 'Profile' },
];

export default function BottomNav({ onMenuTap }) {
  const location = useLocation();
  const { viewMode } = useAuth();

  const isClient = viewMode === 'client';
  const TABS = isClient ? CLIENT_TABS : REP_TABS;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/90 backdrop-blur-xl safe-area-bottom"
      style={{ borderTop: '1px solid var(--line)', boxShadow: '0 -4px 16px rgba(15,23,42,0.06)' }}
    >
      <div className="flex items-center justify-around h-16">
        {TABS.map(({ path, icon: Icon, label }) => {
          const active = location.pathname === path;
          return (
            <Link key={path} to={path} onClick={() => haptic()} className="relative flex flex-col items-center justify-center flex-1 h-full transition-colors">
              {active && (
                <span
                  className="absolute top-0 w-8 h-[2.5px] rounded-b-full"
                  style={{ background: 'linear-gradient(90deg, var(--brand-500), var(--brand-700))' }}
                />
              )}
              <Icon size={20} className={active ? '' : 'text-gray-400'} style={active ? { color: 'var(--brand-600)' } : undefined} />
              <span
                className={`text-[10px] mt-0.5 ${active ? 'font-semibold' : 'text-gray-400 font-medium'}`}
                style={active ? { color: 'var(--brand-600)' } : undefined}
              >{label}</span>
            </Link>
          );
        })}
        {!isClient && (
          <button onClick={() => { haptic(); onMenuTap(); }} className="flex flex-col items-center justify-center flex-1 h-full transition-colors hover:text-gray-600">
            <Menu size={20} className="text-gray-400" />
            <span className="text-[10px] mt-0.5 text-gray-400 font-medium">More</span>
          </button>
        )}
      </div>
    </div>
  );
}
